import * as React from 'react'

import { Box, Divider, Table } from '@factorialco/deprecated-design-system'
import { getUnixTime } from 'date-fns/getUnixTime'
import { parseISO } from 'date-fns/parseISO'
import {
  CompetenciesEmployeesRootPageAssessmentGroupFragment,
  CompetenciesProfileRootPageAssessmentGroupFragment,
} from 'generated/resources/graphql'

import CompetencyRow from './CompetenciesRow'
import Navigator from './Navigator'
import SpiderWeb from './SpiderWeb'

interface Props {
  assessmentGroup:
    | CompetenciesProfileRootPageAssessmentGroupFragment
    | CompetenciesEmployeesRootPageAssessmentGroupFragment
  hasNextPage: boolean
  hasPreviousPage: boolean
  onNextPage: () => void
  onPreviousPage: () => void
}

const toUnixTime = (date: string) => {
  return getUnixTime(parseISO(date))
}

const Competencies = ({
  assessmentGroup,
  hasNextPage,
  hasPreviousPage,
  onNextPage,
  onPreviousPage,
}: Props) => {
  return (
    <Table>
      <Table.Body>
        <Table.Row>
          <Box flexDirection="column" width="full">
            <Box
              flexDirection="row"
              padding="s16"
              justifyContent="spaceBetween"
              aria-label="assessment-navigator"
              background="grey100"
            >
              <Navigator
                hasNextPage={hasNextPage}
                hasPreviousPage={hasPreviousPage}
                onNextPage={onNextPage}
                onPreviousPage={onPreviousPage}
                currentDate={toUnixTime(assessmentGroup.publishedAt)}
              />
            </Box>
            <Divider />
            <SpiderWeb assessments={assessmentGroup.assessments} />
            {assessmentGroup.assessments.map((assessment) => {
              return (
                <>
                  <Divider />
                  <CompetencyRow key={assessment.id} assessment={assessment} />
                </>
              )
            })}
          </Box>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}

export default Competencies
